"use client";
import { cdnFlightPath } from "@/constants/cdnUrls";
import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Button } from "./ui/Button";
import { Ellipse, YellowUnderLine } from "./ui/Icon";

export default function AppBanner() {
  const t = useTranslationDetector("common");
  const [storeUrl, setStoreUrl] = useState("#");

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      setStoreUrl(
        "https://turna.go.link?adj_t=1yuvchll&adj_engagement_type=fallback_click",
      );
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setStoreUrl(
        "https://turna.go.link?adj_t=1yuvchll&adj_engagement_type=fallback_click",
      );
    } else {
      setStoreUrl(null); // desteklenmeyen cihaz
    }
  }, []);

  return (
    <div className="bg-appbanner-gradient relative flex h-[504px] w-full flex-col items-center justify-center overflow-hidden rounded-lg md:flex-row lg:h-100 lg:justify-between lg:pr-30 lg:pl-14">
      <div className="md:gap:0 flex max-w-[342px] flex-col items-center justify-center gap-6 p-6 pb-0 md:items-start md:p-0 lg:max-w-[562px]">
        <div className="relative hidden h-9 w-44 lg:block">
          <Image
            src="/images/dummy/turna-logo-size.png"
            alt="app-banner-device"
            fill
            className=""
          />
        </div>
        <div className="relative w-full">
          <h2 className="color-foreground text-xl-custom m-0 inline-flex flex-wrap gap-x-1 text-center leading-9 font-semibold md:text-left lg:text-4xl lg:leading-12">
            <span>{t("appBannerTitle")}</span>
            <span className="relative">
              {t("appBannerTitleHighlight")}
              <span className="absolute bottom-[-10] left-1 w-full lg:left-2">
                <YellowUnderLine />
              </span>
            </span>
            <span>
              {t("appBannerTitleHighlight2")}
              {t("appBannerTitleEnd")}
            </span>
          </h2>
        </div>

        <p className="text-primary-muted-subtext text-center text-base font-normal md:text-left lg:hidden">
          {t("appBannerDescriptionMobile")}
        </p>
        <p className="text-primary-muted-subtext hidden text-center text-lg font-normal md:text-left lg:block">
          {t("appBannerDescriptionDesktop")}
        </p>
        <Button
          className="h-[50px] w-[251px] lg:hidden"
          href={storeUrl}
          target="_blank"
        >
          {t("appBannerDownloadButton")}
        </Button>
      </div>

      <div className="relative bottom-[-60px] h-[330px] w-[80%] max-w-[340px] md:h-[400px] lg:hidden">
        <Image
          src={`${cdnFlightPath}app-banner/Smartphones-mobile-v2.png`}
          alt="app-banner-device"
          fill
          className=""
        />
      </div>
      <div className="relative bottom-[-30px] hidden h-[100px] w-[80%] max-w-[420px] md:h-[350px] lg:block">
        <Image
          src={`${cdnFlightPath}app-banner/Smartphones-desktop-v2.png`}
          alt="app-banner-device"
          fill
          className=""
        />
      </div>
      <div className="absolute top-10 left-14 hidden h-2 w-2 lg:block">
        <Ellipse className="h-2 w-2" />
      </div>

      <div className="absolute right-14 bottom-40 hidden h-2 w-2 xl:block">
        <Ellipse className="h-2 w-2" />
      </div>
    </div>
  );
}
